const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function trackPublicCTA(payload) {
  try {
    await fetch(`${API_URL}/api/public-funnel/track-cta`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (err) {
    console.error('CTA tracking failed:', err);
  }
}
